
























































import { Vue, Component, Watch } from "vue-property-decorator";
import SelectEntity from "@/components/form/SelectEntity.vue";
import { User as IUser } from "@/api/models/user";
import CourseListeners, {
  CourseListenersListParams
} from "@/getinfo-api/course-listeners";
import { UsersList as IUsersList } from "@/api/models/users-list";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";
import LearningResourceTable from "@/components/contract/LearningResourceTable.vue";
import api from "@/getinfo-api";
import courseRegistrations, {
  CourseRegistrationsListParams
} from "@/getinfo-api/courseRegistrations";
import { Student as IStudent } from "@/api-v2/course/models/student";
import CustomButton from "@/components/form/CustomButton.vue";
import { LearningResourceInfo as ILearningResourceInfo } from "@/api/models/learning-resource-info";

@Component({
  components: { CustomButton, LearningResourceTable, SelectEntity }
})
export default class LearningResources extends Vue {
  resourceType: string = "course";
  selectedResource!: any;
  contractLearningResource!: ILearningResourceInfo;
  listeners!: Array<ICourseListener>;
  gettingUsers: boolean = false;
  users: Array<IUser> = [];
  price: number = 0;
  searchUsersByEmail!: string;

  data() {
    return {
      searchUsersByEmail: undefined,
      selectedResource: undefined,
      contractLearningResource: {} as ILearningResourceInfo
    };
  }

  @Watch("resourceType")
  checkResourceType() {
    this.users = [];
  }

  @Watch("price")
  checkPrice() {
    if (this.price && this.contractLearningResource?.userIds) {
      this.contractLearningResource.price = this.$converter.setPrice(
        this.price
      );
      this.contractLearningResource.amount =
        this.contractLearningResource.userIds.length *
        this.contractLearningResource.price;
    }
  }

  @Watch("searchUsersByEmail")
  updUsers() {
    this.getCourseListeners();
  }

  @Watch("selectedResource")
  checkSelectedResource() {
    this.users = [];
    if (this.selectedResource) {
      this.contractLearningResource = {
        id: this.selectedResource.id,
        type: this.resourceType,
        creationMethod: 0,
        title: this.selectedResource.title,
        price: this.$converter.setPrice(this.price),
        userIds: [],
        amount: 0,
        ownerFirstName: this.selectedResource.owner.firstName
          ? this.selectedResource.owner.firstName
          : "",
        ownerMiddleName: this.selectedResource.owner.middleName
          ? this.selectedResource.owner.middleName
          : "",
        ownerLastName: this.selectedResource.owner.lastName
          ? this.selectedResource.owner.lastName
          : "",
        hours: this.selectedResource.hours ? this.selectedResource.hours : 0,
        ownerFullName: this.selectedResource.owner.fullName,
        program: this.selectedResource.program,
        activity: this.selectedResource.activity,
        specialty: this.selectedResource.specialty,
        qualification: this.selectedResource.qualification,
        documentType: this.selectedResource.documentType
      };
      this.users = [];
      if (this.resourceType === "course") {
        this.getCourseListeners();
      }
      if (this.resourceType === "webinar") {
        this.getWebinarListeners();
      }
      if (this.resourceType === "video") {
        this.getVideoListeners();
      }
    }
  }

  get resourceTypeEntity() {
    let item;
    if (this.resourceType === "course") item = "courses";
    if (this.resourceType === "webinar") item = "webinars";
    if (this.resourceType === "video") item = "videos";
    return item;
  }

  getCheckedUserIds(item: Array<string>) {
    this.contractLearningResource.userIds = item;
    this.contractLearningResource.amount =
      this.contractLearningResource.userIds.length *
      this.contractLearningResource.price;
  }

  getResource(item: any) {
    if (item) {
      this.selectedResource = item;
      this.price = this.$converter.getPrice(this.selectedResource.price);
    }
  }

  getVideoListeners() {
    this.users = [];
    this.gettingUsers = true;
    api.VideoApi.getViewers(this.selectedResource.id)
      .then((res: { data: IUsersList }) => {
        if (res.data.users) this.users = res.data.users;
      })
      .finally(() => {
        this.gettingUsers = false;
      });
  }

  getWebinarListeners() {
    this.users = [];
    this.gettingUsers = true;
    api.WebinarApi.getViewers(this.selectedResource.id)
      .then((res: { data: IUsersList }) => {
        if (res.data.users) this.users = res.data.users;
      })
      .finally(() => {
        this.gettingUsers = false;
      });
  }

  async v1Listeners() {
    this.gettingUsers = true;
    this.users = [];
    let params: CourseListenersListParams = {
      id: this.selectedResource.id,
      enabled: true,
      fullName: this.searchUsersByEmail,
      sort: "createdAt",
      order: "DESC",
      limit: 30
    };

    try {
      const { data } = await CourseListeners(params);
      this.users = data.listeners.map(el => el.user);
    } catch (err) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: err.response
      });
    } finally {
      this.gettingUsers = false;
    }
  }

  async v2Listeners() {
    this.gettingUsers = true;
    this.users = [];
    const params: CourseRegistrationsListParams = {
      limit: 30,
      companyId: this.selectedResource?.company?.id,
      courseIds: [this.selectedResource?.id],
      studentName: this.searchUsersByEmail,
      sort: "startedAt",
      order: "DESC"
    };
    try {
      const { data } = await courseRegistrations(params);
      let students: Array<IStudent> = data.items
        ?.filter(el => !el.isFinished)
        ?.map(el => el.student);
      students.forEach(
        el =>
          //@ts-ignore
          (el.fullName = `${el.lastName} ${el.firstName} ${
            el.middleName ? el.middleName : ""
          }`)
      );
      //@ts-ignore
      this.users = students;
    } finally {
      this.gettingUsers = false;
    }
  }

  getCourseListeners() {
    if (this.selectedResource.version !== "v2") {
      this.v1Listeners();
    } else {
      this.v2Listeners();
    }
  }

  cancelContractLearningResource() {
    this.$emit("cancel");
  }

  addContractLearningResource() {
    if (this.contractLearningResource?.userIds?.length) {
      this.$emit("getContractLearningResource", this.contractLearningResource);
    } else {
      this.$bvToast.toast(
        `${this.$tc(this.$translate.AtLeastOneUserMustBeSelected)}`,
        {
          variant: "danger",
          title: `${this.$tc(this.$translate.Error)}`
        }
      );
    }
  }

  get currentCompany() {
    return this.$store.getters.selectedCompany;
  }
}
